import { useState } from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import imageStep1 from './images/sporttia1_smartcourt.jpeg';
import imageStep2 from './images/sporttia2_smartcourt.jpeg';
import imageStep3 from './images/sporttia3_smartcourt.jpeg';
import imageStep4 from './images/sporttia4_smartcourt.jpeg';
import imageStep5 from './images/sporttia5_smartcourt.jpeg';
import imageStep6 from './images/sporttia6_smartcourt.jpeg';
import imageStep7 from './images/sporttia7_smartcourt.jpeg';

import { SttButton } from '../../sporttia/all';

export default function SmartCourt(): React.ReactElement {
    const [currentStep, setCurrentStep] = useState(0);
    const [imageZoom, setImageZoom] = useState<string | null>(null);
    const { t } = useTranslation();

    // All five steps to show to the user with each correspondent description and images
    const steps = [
        <Grid
            container
            justifyContent="center"
            direction="row"
            key="step1"
            size={{ xs: 12 }}
        >
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.titleStep1')}</Typography>
            </Grid>
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.textStep1')}</Typography>
            </Grid>
            <Grid container justifyContent="center" size={{ xs: 6 }}>
                <a href="https://play.google.com/store/apps/details?id=es.sporttia.sporttia&gl=ES&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                    <Box
                        component="img"
                        src="https://www.sporttia.com/wp-content/uploads/2020/05/4-3.png"
                    />
                </a>
            </Grid>
            <Grid container justifyContent="center" size={{ xs: 6 }}>
                <a href="https://apps.apple.com/es/app/sporttia/id1093457829">
                    <Box
                        component="img"
                        src="https://www.sporttia.com/wp-content/uploads/2020/05/3-2.png"
                    />
                </a>
            </Grid>
        </Grid>,
        <Grid
            container
            justifyContent="center"
            direction="column"
            key="step2"
            size={{ xs: 12 }}
        >
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.titleStep2')}</Typography>
            </Grid>
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.textStep2')}</Typography>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="center"
                size={{ xs: 12 }}
            >
                <Grid container justifyContent="center" size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep1}
                        onClick={() => setImageZoom(imageStep1)}
                    />
                </Grid>
                <Grid container justifyContent="center" size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep2}
                        onClick={() => setImageZoom(imageStep2)}
                    />
                </Grid>
            </Grid>
        </Grid>,
        <Grid
            container
            justifyContent="center"
            direction="column"
            key="step3"
            size={{ xs: 12 }}
        >
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.titleStep3')}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Typography>{t('smartcourt.textStep3')}</Typography>
            </Grid>

            <Grid
                container
                justifyContent="center"
                direction="row"
                size={{ xs: 12 }}
            >
                <Grid size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep3}
                        onClick={() => setImageZoom(imageStep3)}
                    />
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep4}
                        onClick={() => setImageZoom(imageStep4)}
                    />
                </Grid>
            </Grid>
        </Grid>,
        <Grid
            container
            justifyContent="center"
            direction="column"
            key="step4"
            size={{ xs: 12 }}
        >
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.titleStep4')}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Typography>{t('smartcourt.textStep4')}</Typography>
            </Grid>
            <Grid
                container
                justifyContent="center"
                direction="row"
                size={{ xs: 12 }}
            >
                <Grid size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep5}
                        onClick={() => setImageZoom(imageStep5)}
                    />
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <Box
                        component="img"
                        src={imageStep6}
                        onClick={() => setImageZoom(imageStep6)}
                    />
                </Grid>
            </Grid>
        </Grid>,
        <Grid
            container
            justifyContent="center"
            direction="column"
            key="step5"
            size={{ xs: 12 }}
        >
            <Grid container justifyContent="center" size={{ xs: 12 }}>
                <Typography>{t('smartcourt.titleStep5')}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Typography>
                    <b>1.</b> {t('smartcourt.textStep5.1')}
                </Typography>
                <Typography>
                    <b>2.</b> {t('smartcourt.textStep5.2')}
                </Typography>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="center"
                size={{ xs: 12 }}
            >
                <Grid container justifyContent="center" size={{ xs: 6 }}>
                    <Box component="img" src={imageStep7} />
                </Grid>
            </Grid>
        </Grid>,
    ];

    return (
        <>
            {imageZoom ? (
                <Grid container justifyContent="center">
                    <Box
                        component="img"
                        src={imageZoom}
                        onClick={() => setImageZoom(null)}
                    />
                </Grid>
            ) : (
                <Grid container direction="column" spacing={3}>
                    <Grid container size={{ xs: 12 }}>
                        <Grid
                            container
                            justifyContent="center"
                            size={{ xs: 12 }}
                        >
                            <Typography>SMARTCOURT</Typography>
                        </Grid>
                        <Grid
                            container
                            justifyContent="center"
                            size={{ xs: 12 }}
                        >
                            <Typography>{t('smartcourt.subtitle')}</Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        size={{ xs: 12 }}
                    >
                        <Paper>{steps[currentStep]}</Paper>
                        <Grid
                            container
                            justifyContent="center"
                            size={{ md: 12 }}
                        >
                            <Box>
                                <SttButton
                                    icon={
                                        currentStep < steps.length - 1 ? (
                                            <ArrowForward />
                                        ) : (
                                            <ArrowBack />
                                        )
                                    }
                                    color="primary"
                                    variant="contained"
                                    caption={
                                        currentStep < steps.length - 1
                                            ? 'Siguiente'
                                            : 'Volver'
                                    }
                                    onClick={() => {
                                        if (currentStep < steps.length - 1) {
                                            setCurrentStep(currentStep + 1);
                                        } else setCurrentStep(0);
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    );
}
